import { importNewList } from "./import-new-list";
import { newList } from "./new-list";
import { report } from "./report";
import { infos } from "./infos";
import { promoter } from "./promoter";

export const guestList = {
	promoter,
	title: "Guest list",
	importList: "Import List",
	createList: "Create List",
	searchList: "search list",
	list_one: "List",
	list_other: "Lists",
	guestsNotImported: "Guests not imported",
	addGuestError: {
		relationReachesLimit: "List has already reached the guest limit",
		userAlreadyExists: "Guest already registered on the list",
		userWithoutDocument: "Guest without document",
	},
	columns: {
		name: "List Name",
		description: "Description",
		userCount: "Guests",
		guest: "Guest",
		expiresAt: "Expiration",
		status: "Status",
		active: "ACTIVE",
		inactive: "DISABLED",
	},

	deleteModal: {
		title: "Delete List",
		message: "Are you sure you want to delete these lists?",
		confirm: "Delete List",
	},
	importNewList,
	newList,
	report,
	emptyList: {
		defaultMessage: "Looks like you haven't created a list yet.",
		defaultText: "The lists will appear here when you have a registered list.",
	},
	infos,
	menuDrop: {
		disable: "Disable list",
		enable: "Enable List",
		download: "Download",
		print: "Print",
		edit: "Edit",
		delete: "Delete",
	},
	sheet: {
		filename: "list_{{name}}",
		title: "List: {{name}}",
		columns: {
			name: "Name",
			cpf: "CPF",
			phone: "Phone",
			promoter: "Promoter",
		},
		example: "list (example)",
		error: "Invalid worksheet",
	},
	list: {
		goBack: "Back to Lists",
		import: {
			label: "Import guest sheet",
			description: "To import a guest list just upload a spreadsheet",
		},
		sheet: {
			title: "Guest List",
			error:
				"Invalid worksheet, download it again and make the necessary changes. In case of empty lines in red, delete and try again.",
		},
		success: "Worksheet imported successfully",
		warning: "Before importing the spreadsheet, ensure that all blank lines are removed",
		delete: {
			permanentlyList: "Permanently delete list",
			permanentlyLists: "Permanently delete lists",
			list: "Delete list",
			lists: "Delete lists",
			selectedList:
				"The selected list will be permanently removed and its information (guests, check-in, average ticket, entry, consumption, promoters) will be removed from the reports. This action cannot be undone. Do you want to continue anyway?",
			selectedLists:
				"The selected lists will be permanently removed and their information (guests, check-in, average ticket, entry, consumption, promoters) will be removed from the reports. This action cannot be undone. Do you want to continue anyway?",
		},
		print: {
			noEntrance: "No entry associated with this list.",
			date: "Issuance date",
			entrance: "Associated entry",
			discount: "Discount type",
			description: "Description",
			expiresAt: "Expires at",
		},
	},
	utils: {
		expiresAt: "Expires in",
		hasExpired: "Expired there",
		expires: "Expires",
		invalidName: "Invalid name",
		insertLastName: "Insert a last name",
	},
};
